import React from "react"
import styled from "styled-components"
import warning from "../../../../../images/warning.svg"

const SPEEDBUMP_TYPES = {
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warning',
  }


const Container = styled.div`
    background-color: ${ props => {
        if (props.$speedBumpTypes === SPEEDBUMP_TYPES.ERROR) {
            return '#FFDBDB'
        } else if (props.$speedBumpTypes === SPEEDBUMP_TYPES.WARNING) {
            return '#FCF1D6'
        }
        return '#DFF2FF'
    }};
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 13px 16px 16px 12px;
    border-radius: 8px;
    margin: 16px 16px 30px 16px;
`;

const SpeedBumpIcon = styled.i`
    background-image: url(${props => props.$icon});
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    flex-basis: 24px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 6px;
`

const SpeedBumpHeadline = styled.div`
    font-family: Circular;
    font-weight: 700;
    color: #4A4A4A;
    line-height: 18px;
    padding-bottom: 2px;
`

const SpeedBumpContent = styled.div`
    font-family: Circular;
    font-weight: 400;
    flex-shrink: 1;
    color: #4A4A4A;
    line-height: 18px;
    padding-top: 2px;
`

const SpeedBumpBanner = ({
    bodyText = '',
    headlineText = null,
    type = SPEEDBUMP_TYPES.INFO,
}) => {

    return (
        <div>
            <Container $speedBumpTypes={type}>
                <SpeedBumpIcon $icon={warning}/>
                <SpeedBumpHeadline>{headlineText}
                    <SpeedBumpContent>
                        {bodyText}
                    </SpeedBumpContent>
                </SpeedBumpHeadline>
            </Container>
        </div>
    )
}

export default SpeedBumpBanner
